import jQuery from 'jquery';
const $ = jQuery;
const darkChocolateFull = 'assets/models/dark_chocolate_full.glb';
const darkChocolate = 'assets/models/dark_chocolate.glb';
const hazelnutFull = 'assets/models/hazelnut_full.glb';
const hazelnut = 'assets/models/hazelnut.glb';

const envnx = 'assets/textures/env/nx.png';
const envpx = 'assets/textures/env/px.png';
const envny = 'assets/textures/env/ny.png';
const envpy = 'assets/textures/env/py.png';
const envnz = 'assets/textures/env/nz.png';
const envpz = 'assets/textures/env/pz.png';

const Tick = 'assets/textures/Tick.png';
const scoreENG = 'assets/textures/score_ENG.png';
const deductENG = 'assets/textures/deduct_ENG.png';
const scoreARB = 'assets/textures/score_ARB.png';
const deductARB = 'assets/textures/deduct_ARB.png';
const particle1 = 'assets/textures/particle1.png';
const particle2 = 'assets/textures/particle2.png';
const particle3 = 'assets/textures/particle3.png';
const flavourLeaderboardENG = 'assets/textures/Flavour-Leaderboard_ENG.png';
const flavourLeaderboardARB = 'assets/textures/Flavour-Leaderboard_ARB.png';

const leaderboard1ENG = 'assets/textures/leaderboard1_ENG.png';
const leaderboard1ARB = 'assets/textures/leaderboard1_ARB.png';
const leaderboard2ENG = 'assets/textures/leaderboard2_ENG.png';
const leaderboard2ARB = 'assets/textures/leaderboard2_ARB.png';
const leaderboard3ENG = 'assets/textures/leaderboard3_ENG.png';
const leaderboard3ARB = 'assets/textures/leaderboard3_ARB.png';
const chocolateLabelENG = 'assets/textures/dark_chocolate_label_ENG.png';
const chocolateScoreENG = 'assets/textures/score_chocolate_ENG.png';
const chocolateScoreARB = 'assets/textures/score_chocolate_ARB.png';
const hazelnutScoreENG = 'assets/textures/score_hazelnut_ENG.png';
const hazelnutScoreARB = 'assets/textures/score_hazelnut_ARB.png';

const hazelnutLabelENG = 'assets/textures/hazelnut_label_ENG.png';
const chocolateLabelARB = 'assets/textures/dark_chocolate_label_ARB.png';
const hazelnutLabelARB = 'assets/textures/hazelnut_label_ARB.png';
const leaderPlatformENG = 'assets/textures/leader_platform_ENG.png';
const leaderPlatformARB = 'assets/textures/leader_platform_ARB.png';

const Global = {
  baseURL: 'https://192.168.1.124:5173/', //'https://alivenow.staging.8thwall.app/oreo-stay-playful/',
  volumeBool: true,
  BLOOM_SCENE: 1,
  itemsToRayCastRight: [],
  itemsToRayCastLeft: [],
  itemsToRayCastDown: [],
  itemsToRayCastUp: [],
  itemsToCollect: [],
  itemsToAvoid: [],
  energyTotal: 0,
  userId: null,
  playCount: 0,
  goBackScreen: '',
  scoreTotal: 0,
  isGameActive: false,
  gameTime: 45,
  gameFinished: false,
  levelSelected: 2,
  isGyroActive: true,
  backgroundIntensity: 0.8,
  delta: 1,
  isWindowActive: true,
  ambient1Active: false,
  ambient2Active: false,
  clockStopped: false,
  deviceOrientationAvailable: false,
  serverObj: null,
  gameTry: 0,
  roomID: null,
  playerIndex: 1,
  playerName: 'Player1',
  U_ID: '843922496',
  gameID: '843922496',
  gameMode: '2player',
  gameKey: 'ABCorOyqvqOAAAAA',
  signInError: 'mobileError',
  signUpError: 'mobileError',
  fps: 60,
  loginStatus: false,
  lang: 'ENG',
  BASE_URL: 'https://newsfeedsmartapp.com/OreoNewFlavour/api/',
  clickUpdater(clm) {
    $.ajax({
      url: 'https://newsfeedsmartapp.com/OreoNewFlavour/api/clickUpdater.php',
      method: 'POST',
      dataType: 'json',
      data: {
        uid: Global.U_ID,
        saveType: clm,
      },
      success(responseData) {
        // console.log(responseData);

        if (responseData.code == 200) {
        }
      },
      error(jqXHR, textStatus, errorThrown) {
        //  localStorage.clear()
        //  window.location.href = '/';
      },
    });
  },
  repeatCnts: [20, 23, 22, 20, 23, 22, 22, 13],
  controlType: null,
  collectableType: 'chocolate',
  assets: {
    cubemap: {
      0: {
        key: 'environmentMapTexture',
        path: [envnx, envpx, envny, envpy, envnz, envpz],
        asset: null,
      },
    },
    textures: {
      Tick: {
        key: 'Tick',
        path: [Tick],
        asset: null,
      },
      scoreENG: {
        key: 'scoreENG',
        path: [scoreENG],
        asset: null,
      },
      deductENG: {
        key: 'deductENG',
        path: [deductENG],
        asset: null,
      },
      scoreARB: {
        key: 'scoreARB',
        path: [scoreARB],
        asset: null,
      },
      deductARB: {
        key: 'deductARB',
        path: [deductARB],
        asset: null,
      },
      particle1: {
        key: 'particle1',
        path: [particle1],
        asset: null,
      },
      particle2: {
        key: 'particle2',
        path: [particle2],
        asset: null,
      },
      particle3: {
        key: 'particle3',
        path: [particle3],
        asset: null,
      },
      flavour_leaderboard_ENG: {
        key: 'flavour_leaderboard_ENG',
        path: [flavourLeaderboardENG],
        asset: null,
      },
      flavour_leaderboard_ARB: {
        key: 'flavour_leaderboard_ARB',
        path: [flavourLeaderboardARB],
        asset: null,
      },
      leaderboard1_ENG: {
        key: 'leaderboard1_ENG',
        path: [leaderboard1ENG],
        asset: null,
      },
      leaderboard1_ARB: {
        key: 'leaderboard1_ARB',
        path: [leaderboard1ARB],
        asset: null,
      },
      leaderboard2_ENG: {
        key: 'leaderboard2_ENG',
        path: [leaderboard2ENG],
        asset: null,
      },
      leaderboard2_ARB: {
        key: 'leaderboard2_ARB',
        path: [leaderboard2ARB],
        asset: null,
      },
      leaderboard3_ENG: {
        key: 'leaderboard3_ENG',
        path: [leaderboard3ENG],
        asset: null,
      },
      leaderboard3_ARB: {
        key: 'leaderboard3_ARB',
        path: [leaderboard3ARB],
        asset: null,
      },
      chocolate_score_ENG: {
        key: 'chocolate_score_ENG',
        path: [chocolateScoreENG],
        asset: null,
      },
      chocolate_score_ARB: {
        key: 'chocolate_score_ARB',
        path: [chocolateScoreARB],
        asset: null,
      },
      hazelnut_score_ENG: {
        key: 'hazelnut_score_ENG',
        path: [hazelnutScoreENG],
        asset: null,
      },
      hazelnut_score_ARB: {
        key: 'hazelnut_score_ARB',
        path: [hazelnutScoreARB],
        asset: null,
      },
      chocolate_label_ENG: {
        key: 'chocolate_label_ENG',
        path: [chocolateLabelENG],
        asset: null,
      },
      chocolate_label_ARB: {
        key: 'chocolate_label_ARB',
        path: [chocolateLabelARB],
        asset: null,
      },
      hazelnut_label_ENG: {
        key: 'hazelnut_label_ENG',
        path: [hazelnutLabelENG],
        asset: null,
      },
      hazelnut_label_ARB: {
        key: 'hazelnut_label_ARB',
        path: [hazelnutLabelARB],
        asset: null,
      },
      leader_platform_ENG: {
        key: 'leader_platform_ENG',
        path: [leaderPlatformENG],
        asset: null,
      },
      leader_platform_ARB: {
        key: 'leader_platform_ARB',
        path: [leaderPlatformARB],
        asset: null,
      },
    },
    glbs: {
      chocolate_full: {
        key: 'chocolate_full',
        path: [darkChocolateFull],
        asset: null,
      },
      chocolate: {
        key: 'chocolate',
        path: [darkChocolate],
        asset: null,
      },
      hazelnut_full: {
        key: 'hazelnut_full',
        path: [hazelnutFull],
        asset: null,
      },
      hazelnut: {
        key: 'hazelnut',
        path: [hazelnut],
        asset: null,
      },
    },
    sounds: {},
  },
};
export default Global;
